import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import api from '../../api/api'

export const get_seller_request = createAsyncThunk(
    'seller/get_seller_request',
    async ({ parPage, page, searchValue }, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get(`/request-seller-get?page=${page}&&searchValue=${searchValue}&&parPage=${parPage}`, { withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)

export const get_seller = createAsyncThunk(
    'seller/get_seller',
    async (sellerId, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get(`/get-seller/${sellerId}`, { withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)

export const get_seller_comprehensive = createAsyncThunk(
    'seller/get_seller_comprehensive',
    async (sellerId, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get(`/get-seller-comprehensive/${sellerId}`, { withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)

export const seller_status_update = createAsyncThunk(
    'seller/seller_status_update',
    async (info, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.post(`/seller-status-update`, info, { withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)

export const delete_seller = createAsyncThunk(
    'seller/delete_seller',
    async (sellerId, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.delete(`/delete-seller/${sellerId}`, { withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)

export const admin_update_seller_plan = createAsyncThunk(
    'seller/admin_update_seller_plan',
    async ({ sellerId, planData }, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.put(`/admin/update-seller-plan/${sellerId}`, planData, { withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)

export const toggle_top_seller = createAsyncThunk(
    'seller/toggle_top_seller',
    async (sellerId, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.put(`/admin/toggle-top-seller/${sellerId}`, {}, { withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const get_active_sellers = createAsyncThunk(
    'seller/get_active_sellers',
    async ({ parPage, page, searchValue }, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get(`/get-sellers?page=${page}&&searchValue=${searchValue}&&parPage=${parPage}`, { withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const get_deactive_sellers = createAsyncThunk(
    'seller/get_active_sellers',
    async ({ parPage, page, searchValue }, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get(`/get-deactive-sellers?page=${page}&&searchValue=${searchValue}&&parPage=${parPage}`, { withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)

export const bulk_seller_action = createAsyncThunk(
    'seller/bulk_seller_action',
    async ({ sellerIds, action }, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.put('/admin/bulk-seller-action', { sellerIds, action }, { withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)

export const create_stripe_connect_account = createAsyncThunk(
    'seller/create_stripe_connect_account',
    async () => {
        try {
            const { data: { url } } = await api.get(`/payment/create-stripe-connect-account`, { withCredentials: true })
            window.location.href = url
           // return fulfillWithValue(data)
        } catch (error) {
            //return rejectWithValue(error.response.data)
        }
    }
)

export const active_stripe_connect_account = createAsyncThunk(
    'seller/active_stripe_connect_account',
    async (activeCode, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.put(`/payment/active-stripe-connect-account/${activeCode}`, {}, { withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)





export const sellerReducer = createSlice({
    name: 'seller',
    initialState: {
        successMessage: '',
        errorMessage: '',
        loader: false,
        sellers: [],
        totalSeller: 0,
        seller: '',
        comprehensiveData: null,
        comprehensiveLoading: false
    },
    reducers: {
        messageClear: (state, _) => {
            state.errorMessage = ""
            state.successMessage = ""
        }
    },
    extraReducers: {
        [get_seller_request.fulfilled]: (state, { payload }) => {
            state.sellers = payload.sellers
            state.totalSeller = payload.totalSeller
        },
        [get_seller.fulfilled]: (state, { payload }) => {
            state.seller = payload.seller
        },
        [seller_status_update.fulfilled]: (state, { payload }) => {
            state.seller = payload.seller
            state.successMessage = payload.message
        },
        [get_active_sellers.fulfilled]: (state, { payload }) => {
            state.sellers = payload.sellers
            state.totalSeller = payload.totalSeller
        },
        [active_stripe_connect_account.pending]: (state, { payload }) => {
            state.loader = true
        },
        [active_stripe_connect_account.rejected]: (state, { payload }) => {
            state.loader = false
            state.errorMessage = payload.message
        },
        [active_stripe_connect_account.fulfilled]: (state, { payload }) => {
            state.loader = false
            state.successMessage = payload.message
        },
        [delete_seller.pending]: (state, { payload }) => {
            state.loader = true
        },
        [delete_seller.rejected]: (state, { payload }) => {
            state.loader = false
            state.errorMessage = payload.message
        },
        [delete_seller.fulfilled]: (state, { payload }) => {
            state.loader = false
            state.successMessage = payload.message
        },
        [get_seller_comprehensive.pending]: (state, { payload }) => {
            state.comprehensiveLoading = true
        },
        [get_seller_comprehensive.rejected]: (state, { payload }) => {
            state.comprehensiveLoading = false
            state.errorMessage = payload.message
        },
        [get_seller_comprehensive.fulfilled]: (state, { payload }) => {
            state.comprehensiveLoading = false
            state.comprehensiveData = payload.data
        },
        [admin_update_seller_plan.pending]: (state, { payload }) => {
            state.loader = true
        },
        [admin_update_seller_plan.rejected]: (state, { payload }) => {
            state.loader = false
            state.errorMessage = payload.message
        },
        [admin_update_seller_plan.fulfilled]: (state, { payload }) => {
            state.loader = false
            state.seller = payload.seller
            state.successMessage = payload.message
        },
        [toggle_top_seller.pending]: (state) => {
            state.loader = true
        },
        [toggle_top_seller.rejected]: (state, { payload }) => {
            state.loader = false
            state.errorMessage = payload?.message || 'Failed to update top seller status'
        },
        [toggle_top_seller.fulfilled]: (state, { payload }) => {
            state.loader = false
            state.seller = payload.seller
            state.successMessage = payload.message
        },
        [bulk_seller_action.pending]: (state) => {
            state.loader = true
        },
        [bulk_seller_action.rejected]: (state, { payload }) => {
            state.loader = false
            state.errorMessage = payload?.error || 'Bulk action failed'
        },
        [bulk_seller_action.fulfilled]: (state, { payload }) => {
            state.loader = false
            state.successMessage = payload.message
        },
    }

})
export const { messageClear } = sellerReducer.actions
export default sellerReducer.reducer